export const ExchangeIcon = () => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g
        opacity=".2"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11.875 1.875L16.25 6.25l-4.375 4.375M15.58 6.25H3.75M8.125 18.125L3.75 13.75l4.375-4.375M4.453 13.75H16.25" />
      </g>
    </svg>
  );
};
